<template>
  <div>
    <section class="hero is-danger">
      <h3 class="is-size-3">
        グループ・カテゴリ設定
      </h3>
    </section>
    <section class="section">
      <div class="container">
        <div class="hero">
          <div class="field">
            <button class="button is-danger is-size-5 is-rounded" @click="openModal">グループ新規追加</button>
          </div>
        </div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>グループ名</th>
              <th>カテゴリ操作</th>
              <th>グループ操作</th>
              <th>削除</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in getItems" v-bind:key="item.id">
              <th>{{ item.name }}</th>
              <td>
                <button class="button is-link is-rounded" @click="editButtonClick(item)">グループ名の編集</button>
              </td>
              <td>
                <router-link :to="{ name: 'SettingsCategory', params: { group_id: item.id } }">
                  <button class="button is-info is-rounded">カテゴリの追加</button>
                </router-link>
              </td>
              <td>
                <button class="button is-danger is-rounded" @click="deleteButtonClick(item)">削除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <paginate
            v-model="page.currentPage"
            :page-count="getPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'前'"
            :next-text="'次'"
            :container-class="'pagination-list'"
            :page-link-class="'pagination-link'"
            :page-class="''"
            :hide-prev-next="true"
            :prev-link-class="'pagination-previous'"
            :next-link-class="'pagination-next'"
            :active-class="'pagination-link is-current'"
            :no-li-surround="true">
          </paginate>
        </nav>
      </div>
    </section>
    <section class="section">
      <div class="hero">
        <div class="field">
          <button class="button is-link is-size-5 is-rounded" @click="$router.go(-1)">戻る</button>
        </div>
      </div>
    </section>
    <!-- モーダル表示 -->
    <div class="modal" v-bind:class="{'is-active': isModal}">
      <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ modal.title }}</p>
            <button class="delete" aria-label="close" @click="close_popup"></button>
          </header>
          <form @submit.prevent="submit">
            <section class="modal-card-body">
              <div v-if="isErrors">
                <p class="has-text-danger">{{ isErrors }}</p>
              </div>
              <div class="field">
                <div class="field">
                  <label for="" class="label">グループ名</label>
                  <div class="control has-icons-left">
                    <input type="text" placeholder="グループ名" class="input" v-model="inputForm.name" required>
                    <span class="icon is-small is-left">
                      <i class="fa fa-edit"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="h7 is-size-7 has-text-danger" v-show="error.name">※グループ名は必須です。</div>
              <div class="h7 is-size-7 has-text-danger" v-show="error.group">※不明なエラーが発生しました。リロードして最初から操作を行ってください。</div>
            </section>
            <footer class="modal-card-foot">
              <button type="submit" class="button is-success" v-bind:class="{'is-loading':disabled, '':isErrors}">保存</button>
              <button class="button" @click.prevent="close_popup" v-bind:class="{'is-loading':disabled}">キャンセル</button>
            </footer>
          </form>
        </div>
    </div>
    <!-- モーダル表示 end -->
    <!-- モーダル表示 -->
    <div class="modal" v-bind:class="{'is-active': isDeleteModal}">
      <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">グループの削除</p>
            <button class="delete" aria-label="close" @click="close_delete"></button>
          </header>
          <form @submit.prevent="onDelete">
            <section class="modal-card-body">
              <div v-if="isErrors">
                <p class="has-text-danger">{{ isErrors }}</p>
              </div>
              <div class="field">
                <div class="field">
                  <label for="" class="label">グループ名</label>
                  <div class="control has-icons-left">
                    <input type="text" placeholder="グループ名" class="input" v-model="inputForm.name" disabled>
                    <span class="icon is-small is-left">
                      <i class="fa fa-edit"></i>
                    </span>
                  </div>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button type="submit" class="button is-danger" v-bind:class="{'is-loading':disabled, '':isErrors}">削除</button>
              <button class="button" @click.prevent="close_delete" v-bind:class="{'is-loading':disabled}">キャンセル</button>
            </footer>
          </form>
        </div>
    </div>
    <!-- モーダル表示 end -->
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import { mapState, mapActions} from 'vuex'   //Vuex が提供する mapState 関数を使う
const CREATE = 'create'
const EDIT = 'edit'

export default {
  data: function(){
    return {
      isModal: false,
      isDeleteModal: false,
      inputForm: {
        name: '',
        group: '',
      },
      error: {
        name: null,
        group: null,
      },
      page: {
        parPage: 10,
        currentPage: 1
      },
      disabled: false,
      modal: {
        title: 'グループ新規追加',
        alert: 'グループを登録しました',
        mode: '',
      },
    }
  },
  components:{
    'paginate': Paginate,  //https://www.kabanoki.net/4320/
  },
  computed:{
    ...mapState({
      items: state => state.news.groups,
      getItems(state) {   //mapStateの中でthisを使う際にはアローはNG
        this.page.currentPage = state.status.userCurrentPage
        let current = state.status.userCurrentPage * this.page.parPage
        let start = current - this.page.parPage
        return this.items.slice(start, current)
      },
      apiStatus: state => state.news.apiStatus,
      isErrors(state){
        if(state.news.errorMessages){
          this.disabled = false
        }
        return state.news.errorMessages
      }
      
    }),
    getPageCount: function() {
      return Math.ceil(this.items.length / this.page.parPage)
    }
  },
  mounted(){
    this.$store.dispatch('news/newsGroupAndCategory')
  },
  methods:{
    ...mapActions({
      setGroupCurrentPage: 'status/setGroupCurrentPage',
    }),
    clearError () {
      this.$store.commit('news/setErrorMessages', null)
    },
    clearFrom(){
      //初期化
      Object.keys(this.inputForm).forEach((key) => {
        this.$set(this.inputForm, key, null)
      })
    },
    async submit(){
      this.clearError()
      //初期化
      Object.keys(this.error).forEach((key) => {
        this.$set(this.error, key, null)
      })
      if(!this.isValidation()) return false
      this.disabled = true  //ボタンをローディング表示にする
      if(this.modal.mode == CREATE){
        await this.$store.dispatch('news/createGroup', this.inputForm)
      }else if(this.modal.mode == EDIT){
        await this.$store.dispatch('news/editGroup', this.inputForm)
      }
      if(this.apiStatus){
        window.alert(this.modal.alert)
        //ページリロード
        this.reset()
      }
    },
    isValidation() {
      //グループ名のバリデーション
      if(this.inputForm.name === ""){
        this.error.name = true
        return false
      }
      //グループIDのバリデーション
      if(this.inputForm.group === ""){
        this.error.group = true
        return false
      }
      return true
    },
    reset() {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    openModal() {
      //初期化
      this.clearFrom()
      this.clearError()
      this.modal.mode = CREATE
      this.modal.title = 'グループ新規追加'
      this.modal.alert = 'グループを登録しました'
      this.isModal = true
    },
    close_popup(){
      //初期化
      this.clearFrom()
      this.clearError()
      this.isModal = false
    },
    close_delete(){
      //初期化
      this.clearFrom()
      this.clearError()
      this.isDeleteModal = false
    },
    clickCallback: function (pageNum) {
      this.setGroupCurrentPage(Number(pageNum))
    },
    editButtonClick(item){
      //初期化
      this.clearFrom()
      this.clearError()
      this.modal.mode = EDIT
      this.modal.title = 'グループ名の編集'
      this.modal.alert = 'グループの名称を変更しました'
      this.inputForm.name = item.name
      this.inputForm.group = item.id
      this.isModal = true
    },
    async onDelete(){
      await this.$store.dispatch('news/deleteGroup', this.inputForm)
      if(this.apiStatus){
        window.alert('グループを削除しました')
        //ページリロード
        this.reset()
      }
    },
    deleteButtonClick(item){
      //初期化
      this.clearFrom()
      this.clearError()
      this.inputForm.name = item.name
      this.inputForm.group = item.id
      this.isDeleteModal = true
    }
  }
}
</script>

<style scoped>
  .hero {
    text-align: center
  }
</style>